// useSubtypesOffer.js
import { useCallback, useState } from "react";
import { get_sub_type_offer } from "../../services/tarifas";

// Hook encarregat de carregar els subtipus d'oferta.
// Rep sector i tipus d'oferta, consulta el servei i exposa opcions llestes per al select.
export const useSubtypesOffer = () => {
    const [subtypes, setSubtypes] = useState([]);
    const [loading, setLoading] = useState(false);

    // Carrega els subtipus disponibles per a un sector (electric/gas)
    // i un tipus d'oferta (per exemple simple o renovacion).
    const loadSubtypes = useCallback(async (sector_type, type) => {
        // Sense aquests valors no es pot demanar al backend quins subtipus pertoquen.
        if (!type || !sector_type) return;

        setLoading(true);
        try {
            const response = await get_sub_type_offer(sector_type, type);
            // El backend retorna tuples [id, name]; aqui es transformen a objectes
            // { id, name } per facilitar-ne l'ús components React.
            const options = Array.isArray(response?.subtypes_offer_options)
                ? response.subtypes_offer_options.map(([id, name]) => ({ id, name }))
                : [];

            setSubtypes(options);
            return options; // Retorna les opcions carregades per poder-les reutilitzar al moment.
        } catch (error) {
            console.error("Error loading subtypes:", error);
            return [];
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        // Llista final de subtipus preparada per pintar-se a la UI.
        sub_types_offer_options: subtypes,
        loadSubtypes,
        loading
    };
};